export const DAILY = "DAILY";
export const MONTHLY = "MONTHLY";
export const WEEKLY = "WEEKLY";

export const SHOW_PACKAGE = "SHOW_PACKAGE";
export const SHOW_MSISDN = "SHOW_MSISDN";
export const SHOW_OTP = "SHOW_OTP";
export const SHOW_SUCCESS = "SHOW_SUCCESS";
export const BUY_TURN = "BUY_TURN";
export const REGISTER = "REGISTER";

// tab
export const AUCTION_TAB = "AUCTION_TAB";
export const PACKAGE_TAB = "PACKAGE_TAB";
export const PRIZE_TAB = "PRIZE_TAB";
export const CODE_TAB = "CODE_TAB";

export const PACKAGE_DAILY = "UWIN_daily";

export const CLIENTID = "504852ed-0bbc-4972-a392-dc64f5d3600c";

export const PLAY_SHOW_ACTION = "PLAY_SHOW_ACTION";
export const PLAY_SHOW_COUNTDOWN = "PLAY_SHOW_COUNTDOWN";
export const PLAY_SHOW_NO_COUNTDOWN = "PLAY_SHOW_NO_COUNTDOWN";

export const OPENNING = "OPENING";
export const PREPARE = "PREPARE";
export const CLOSED = "CLOSED";
